import React from 'react';
import cx from 'classnames';
import styles from './StatTabs.module.scss';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';

export const StatTabs = ({ stats, activeKey, onTabClick }) => (
  <div className={styles.wrapper}>
    <div className={styles.inner}>
      {stats.map(stat => (
        <button
          key={stat.key}
          type="button"
          className={cx(styles.tab, stat.key === activeKey && styles.tabActive)}
          onClick={() => onTabClick(stat.key)}
        >
          {renderMaxLengthText(stat.label, 19)}
        </button>
      ))}
    </div>
  </div>
);
